export const SORTOPTIONS = {
  PriorityAsc: "Priority ASC",
  PriorityDesc: "Priority DESC",
  SeverityAsc: "Severity ASC",
  SeverityDesc: "Severity DESC",
  NatureAsc: "Nature ASC",
  NatureDesc: "Nature DESC",
  AppAsc: "App ASC",
  AppDesc: "App DESC",
  AssigneeAsc: "Assignee ASC",
  AssigneeDesc: "Assignee DESC",
  Status: "Status",
};
